import React, { useMemo } from 'react';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import EditorString from '../EditorString/EditorString';
import BrandTab from './Tabs/BrandTab';
import ReviewsTab from './Tabs/ReviewsTab';
import SpecificationTab from './Tabs/SpecificationTab';
import { BRAND_TYPE, EDITOR_TYPE, REVIEWS_TYPE } from './ProductTabsConstants';

const StyledTabContentContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${getColor('white')};
  .tab-content {
    width: 100%;
    max-width: 768px;
    padding: 4rem 0;
  }
`;

const ProductTabsContent = ({
  tabItems,
  activeTab,
  showSpecificationsDefaultText,
  specifications,
}) => {
  const activeTabContent = useMemo(() => {
    const tabTitle = activeTab?.split("_")[0].toLowerCase();
    const tab = tabItems?.find(item => item?.key?.toLowerCase() === tabTitle);
    const tabValue = tab?.value
    const tabType = tab?.type?.toUpperCase();

    if (tabType === EDITOR_TYPE) {
      return <EditorString value={tabValue} />;
    }
    else if (tabType === BRAND_TYPE) {
      return <BrandTab brand={tabValue} />;
    }
    else if (tabType === REVIEWS_TYPE) {
      return <ReviewsTab {...tabValue} />;
    }
    else if (tabTitle === "specification") {
      return <SpecificationTab specifications={specifications} showSpecificationsDefaultText={showSpecificationsDefaultText} />;
    }
    else {
      console.warn('Active tab could not be fetched');
    }
  }, [
    tabItems,
    activeTab,
    showSpecificationsDefaultText,
    specifications]);

  return (
    <StyledTabContentContainer>
      <div className="tab-content">{activeTabContent}</div>
    </StyledTabContentContainer>
  );
};

export default ProductTabsContent;
